bcn.cms = (function () {

  'use strict';


  function wrapVideos (cmsContent) {
    cmsContent.find('iframe')
      .removeAttr('style')
      .wrap('<div class="cms-video" />')
      .wrap('<div class="video-wrapper" />');
  }

  function getHeadings (parentDiv) {
    var headings = [];

    parentDiv.find('h2').each(function(i) {
      var $heading = $(this);
      var id = '#heading-' + (i+1);
      $heading.attr('id', id);
      headings.push([$heading.text(), id]);
    });

    return headings;
  }

  function buildMenu (linksHolder) {
    linksHolder.addClass('cms-sub-nav');
    linksHolder.append('<ul class="cms-sub-nav__list" />');
    var list = linksHolder.find('ul');
    var parentDiv = linksHolder.next('.cms-main');
    var headingsArray = getHeadings(parentDiv);
    var headingsLength = headingsArray.length;

    for(var i = 0; i < headingsLength; i++) {

      var li = $('<li class="cms-sub-nav__list-item cms-sub-nav__list-item--down" />')
              .appendTo(list);

      var a = $('<a/>')
              .text(headingsArray[i][0])
              .attr('data-id', i)
              .attr('href', '#heading-' + 1)
              .appendTo(li);
    }
  }

  function clickMenu (linksHolder) {
    linksHolder.on('click', 'a', function () {
      var id = $(this).data('id');
      var target = $('.cms-main h2').eq(id);

      $('html,body').animate({
        scrollTop: target.offset().top
      }, 300);

      if (!target.is('input')) {
        target.attr('tabindex', -1);
      }
      target.focus();
    });
  }

  return {
    init: function () {
      var cmsContent = $('.cms-content');
      if (!cmsContent.length) {
        return;
      }
      wrapVideos(cmsContent);

      if ($('[data-anchor-links]').length) {
        buildMenu($('[data-anchor-links]'));
        clickMenu($('[data-anchor-links]'));
      }
    }
  };

})();
